import MarkUnreadChatAltOutlined from "@mui/icons-material/MarkUnreadChatAltOutlined";
import { usePermissions } from "../../../server/auth/use-permissions";
import { useInboxCount } from "../../layout/components/sidebar/hooks/use-inbox-count";
import { HeaderCount } from "./header-count";

import type { FC } from "react";

/**
 * People with unread SMS replies, as the sidebar's Inbox badge shows. Only super admins can read
 * the count (and see the Inbox), so it is hidden for everyone else, and if the count fails.
 */
export const UnreadInboxCount: FC = () => {
  const { super_admin } = usePermissions();
  const { count, error } = useInboxCount(super_admin);

  if (!super_admin || error) return null;

  return (
    <HeaderCount
      icon={<MarkUnreadChatAltOutlined fontSize="small" />}
      to="/inbox"
      count={count}
      noneTooltip="No new replies"
      someTooltip="You have new unread replies"
    />
  );
};
